import React, { useEffect, useState } from "react";
import { Button, Table, Modal, Form } from "react-bootstrap";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../DashboardLayout";
import {
  fetchFetchableAPIs,
  fetchNetworkStats,
} from "../../../services/axios/apiManager";

// const statsData = [
//   {
//     zone_id: "6635890",
//     total_revenue: 0.00468,
//     total_impressions: 1221,
//     total_clicks: 7,
//     average_CPM: 0.00325987805,
//   },
//   {
//     zone_id: "6635891",
//     total_revenue: 0.0,
//     total_impressions: 281,
//     total_clicks: 0,
//     average_CPM: 0.0,
//   },
//   {
//     zone_id: "6641677",
//     total_revenue: 0.0,
//     total_impressions: 7,
//     total_clicks: 0,
//     average_CPM: 0.0,
//   },
//   {
//     zone_id: "6641679",
//     total_revenue: 0.0,
//     total_impressions: 4,
//     total_clicks: 0,
//     average_CPM: 0.0,
//   },
//   {
//     zone_id: "6636116",
//     total_revenue: 0.0,
//     total_impressions: 41,
//     total_clicks: 0,
//     average_CPM: 0.0,
//   },
//   {
//     zone_id: "6635918",
//     total_revenue: 0.0,
//     total_impressions: 43,
//     total_clicks: 1,
//     average_CPM: 0.0,
//   },
// ];

const AdsNetworkStats = () => {
  const [range, setRange] = useState("");
  const [fetchableAPIs, setFetchableAPIs] = useState([]);
  const [selectedId, setSelectedId] = useState();
  const [selectedDuration, setSelectedDuration] = useState();
  const [dataStats, setDataStats] = useState([]);
  const [loading, setLoading] = useState(true);

  const getfetchableAPIs = async () => {
    setLoading(true);
    const adAPIs = await fetchFetchableAPIs();
    if (adAPIs?.data?.success && adAPIs?.data?.data) {
      setFetchableAPIs(adAPIs.data.data);
      return adAPIs.data.data;
    }
    setLoading(false);
  };

  const getNetworkStats = async (id = selectedId) => {
    if (!id) return;
    const res = await fetchNetworkStats(id);
    if (res?.data?.success && res?.data?.data) {
      setDataStats(res.data.data);
    }
  };

  const getData = async () => {
    const results = await getfetchableAPIs();
    // console.log("results: ", results);
    if (results && results?.length) {
      const { id } = results[0];
      setSelectedId(id);
      await getNetworkStats(id);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <DashboardLayout>
      {/* <div className="row"> */}
      <div className="col-12 mb-3">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item">
                <a>Reports</a>
              </li>
              <li
                className="breadcrumb-item active"
                style={{ color: "#d1cdcdbf" }}
              >
                Stats
              </li>
            </ol>
          </div>
        </div>
      </div>
      {/* <div className="card bg-dark text-white rounded mt-3 mb-3">
        <div className="card-body">
          <h5 className="card-title">Filter by Duration</h5>
          <div className="row align-items-center">
            <div className="col-md-3 mb-2">
              <Form.Select
                className="bg-dark text-light border-light"
                value={range}
                onChange={(e) => {}}
              >
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="quarterly">Quarterly</option>
                <option value="yearly">Yearly</option>
              </Form.Select>
            </div>
          </div>
        </div>
      </div> */}

      <div>
        <div className="bg-dark p-4 rounded mb-4">
          <h4>Ad Network Stats</h4>
          <Table striped bordered hover variant="dark" className="mt-4">
            <thead>
              <tr>
                <th>Ad Unit</th>
                <th>Revenue</th>
                <th>Impressions</th>
                <th>Clicks</th>
                <th>Average CPM</th>
              </tr>
            </thead>
            <tbody>
              {dataStats?.length > 0 &&
                dataStats.map((stat, index) => (
                  <tr key={index}>
                    <td>{stat.zone_id}</td>
                    <td>{stat.total_revenue}</td>
                    <td>{stat.total_impressions}</td>
                    <td>{stat.total_clicks}</td>
                    <td>{stat.average_CPM}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </div>
    </DashboardLayout>
  );
};
export default AdsNetworkStats;
